
    import { defineComponent } from 'vue'

    import { isChristmasToday, isEasterToday } from '@/common/util/holiday-util'

    export default defineComponent({
        props: {
            centered: {
                type: Boolean,
                default: false
            },
            label: {
                type: String,
                required: true
            }
        },
        setup () {
            const isChristmas = isChristmasToday()
            const isEaster = isEasterToday()

            return {
                isChristmas,
                isEaster
            }
        }
    })
